import fetchJsonp from "fetch-jsonp";

export const cart = apiBase => {
  return fetchJsonp(`${apiBase}/cart/cart.json`, {
    cache: "no-cache",
    credentials: "include"
  });
};
